import { SELECT, TEXT, INPUT, NUMBER, INCOME_TEXT } from '..';

import { getTotalIncome } from '../../../utils';

// Employment
export const EMPLOYMENT_CARD_TITLE = 'Employment Info';
const EMPLOYMENT_TITLE = 'Employment & Income';

export const EMPLOYMENT_STATUS = 'Employment Status';

// Employment options
export const FULL_TIME_VALUE = 'full_time';
export const FULL_TIME_TEXT = 'Full Time';

export const PART_TIME_VALUE = 'part_time';
export const PART_TIME_TEXT = 'Part Time';

export const UNEMPLOYED_VALUE = 'unemployed';
export const UNEMPLOYED_TEXT = 'Unemployed';

export const SELF_EMPLOYED_VALUE = 'self_employed';
export const SELF_EMPLOYED_TEXT = 'Self-Employed';

export const OCCUPATION_LABEL = 'Occupation';

export const JOB_TITLE_LABEL = 'Job Title';

export const JOB_DURATION_LABEL = 'Job Duration';

export const YEARS = 'Years';

export const YEAR_0_TEXT = '0 Years';
export const YEAR_1_TEXT = '1 Year';
export const YEAR_2_TEXT = '2 Years';
export const YEAR_3_TEXT = '3 Years';
export const YEAR_4_TEXT = '4 Years';
export const YEAR_5_TEXT = '5 Years';
export const YEAR_6_TEXT = '6 or More';

export const MONTHS = 'Months';

export const HIDDEN = 'hidden';

export const MONTH_0_TEXT = '0 Months';
export const MONTH_1_TEXT = '1 Month';
export const MONTH_2_TEXT = '2 Months';
export const MONTH_3_TEXT = '3 Months';
export const MONTH_4_TEXT = '4 Months';
export const MONTH_5_TEXT = '5 Months';
export const MONTH_6_TEXT = '6 Months';
export const MONTH_7_TEXT = '7 Months';
export const MONTH_8_TEXT = '8 Months';
export const MONTH_9_TEXT = '9 Months';
export const MONTH_10_TEXT = '10 Months';
export const MONTH_11_TEXT = '11 Months';

export const CURRENT_ANNUAL_SALARY = 'Current Annual Salary';

export const BONUSES = 'Bonuses';
export const COMMISSIONS = 'Commissions';

export const SALARY_ATTRIBUTES = [CURRENT_ANNUAL_SALARY, BONUSES, COMMISSIONS];

export const TOTAL_INCOME = 'Total Income';

export const TOTAL_ASSETS = 'Total Assets';

// MODAL INFORMATION
export const EMPLOYMENT_MODAL = {
  title: EMPLOYMENT_TITLE,
  rows: [
    [
      {
        label: EMPLOYMENT_STATUS,
        fieldType: SELECT,
        options: [
          { value: FULL_TIME_VALUE, text: FULL_TIME_TEXT },
          { value: PART_TIME_VALUE, text: PART_TIME_TEXT },
          { value: UNEMPLOYED_VALUE, text: UNEMPLOYED_TEXT },
          { value: SELF_EMPLOYED_VALUE, text: SELF_EMPLOYED_TEXT },
        ],
        onChange: () => {},
      },
    ],
    [
      {
        label: OCCUPATION_LABEL,
        fieldType: INPUT,
        type: TEXT,
        fullWidthOnMobile: true,
        onChange: () => {},
      },
      {
        label: JOB_TITLE_LABEL,
        fieldType: INPUT,
        type: TEXT,
        fullWidthOnMobile: true,
        onChange: () => {},
      },
    ],
    [
      {
        label: JOB_DURATION_LABEL,
        placeholder: YEARS,
        fieldType: SELECT,
        options: [
          { text: YEAR_0_TEXT, value: 0 },
          { text: YEAR_1_TEXT, value: 1 },
          { text: YEAR_2_TEXT, value: 2 },
          { text: YEAR_3_TEXT, value: 3 },
          { text: YEAR_4_TEXT, value: 4 },
          { text: YEAR_5_TEXT, value: 5 },
          { text: YEAR_6_TEXT, value: 6 },
        ],
        isRequired: true,
        onChange: () => {},
      },
      {
        label: JOB_DURATION_LABEL,
        style: { visibility: HIDDEN },
        placeholder: MONTHS,
        fieldType: SELECT,
        options: [
          { text: MONTH_0_TEXT, value: 0 },
          { text: MONTH_1_TEXT, value: 1 },
          { text: MONTH_2_TEXT, value: 2 },
          { text: MONTH_3_TEXT, value: 3 },
          { text: MONTH_4_TEXT, value: 4 },
          { text: MONTH_5_TEXT, value: 5 },
          { text: MONTH_6_TEXT, value: 6 },
          { text: MONTH_7_TEXT, value: 7 },
          { text: MONTH_8_TEXT, value: 8 },
          { text: MONTH_9_TEXT, value: 9 },
          { text: MONTH_10_TEXT, value: 10 },
          { text: MONTH_11_TEXT, value: 11 },
        ],
        isRequired: true,
        onChange: () => {},
      },
    ],
    [
      {
        label: CURRENT_ANNUAL_SALARY,
        placeholder: '$',
        fieldType: INPUT,
        type: NUMBER,
        isRequired: true,
        onChange: () => {},
      },
    ],
    [
      {
        label: BONUSES,
        fieldType: INPUT,
        type: NUMBER,
        onChange: () => {},
      },
      {
        label: COMMISSIONS,
        fieldType: INPUT,
        type: NUMBER,
        onChange: () => {},
      },
    ],
    [
      {
        fieldType: INCOME_TEXT,
        text: TOTAL_INCOME,
        isRequired: true,
        income: getTotalIncome,
        onChange: () => {},
      },
    ],
  ],
};
